import React, { useState, useEffect } from 'react';
import {
  List, ListItem, ListItemText, Drawer, Box, Avatar, Typography,
  IconButton, useMediaQuery, AppBar, Toolbar, Divider, Menu, MenuItem
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine, faUsers, faBullhorn, faTimes, // Added faTimes for the close button
  faLifeRing, faUserCog, faSignOutAlt, faBars, faChevronDown, faCreditCard, faEnvelope, faIdCard
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import YambaFullLogoPng from '../../../../assets/logo.png';
import YambaLogoOnlyPng from '../../../../assets/logo.png'; // Assuming you have a small logo
import baseURL from '../../user/config';

const ORG_COLORS = {
  primary: '#2D4A3D',
  primaryLight: '#EBF4FD',
  text: '#1a1a2e',
  textSecondary: '#8a8f9d',
  background: '#FFFFFF',
  backgroundLight: '#F8F9FB',
  border: '#eaecf0',
  hoverBackground: '#F3F5F8',
  white: '#FFFFFF',
};

const ORGANIZATION_FULL_LOGO = YambaFullLogoPng;
const ORGANIZATION_SMALL_LOGO = YambaLogoOnlyPng; // Use the imported small logo
const drawerWidth = 270;

const OrganizationHeader = ({ onMenuClick, user,organization, handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobile = useMediaQuery('(max-width: 960px)');

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        background: ORG_COLORS.background,
        color: ORG_COLORS.text,
        boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ minHeight: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isMobile ? (
            <img src={ORGANIZATION_SMALL_LOGO} alt="Yamba Logo" style={{ height: '32px' }} />
          ) : (
            <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '0.95rem', color: ORG_COLORS.text, letterSpacing: '-0.2px' }}>
              Dashboard
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isMobile && (
            <IconButton onClick={onMenuClick} sx={{ color: ORG_COLORS.text, width: 36, height: 36 }}>
              <FontAwesomeIcon icon={faBars} size="sm" />
            </IconButton>
          )}
          <Box
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', px: 1, py: 0.5, borderRadius: '10px', '&:hover': { backgroundColor: ORG_COLORS.hoverBackground } }}
            onClick={handleProfileMenuOpen}
          >
            <Avatar alt={user?.name || 'User'} src={organization?.logo_url || '/default-avatar.png'} sx={{ width: 30, height: 30, mr: 1 }} />
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.75 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem', color: ORG_COLORS.text }}>
                {user?.name || 'Guest'}
              </Typography>
              <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '9px', color: ORG_COLORS.textSecondary }} />
            </Box>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
              sx: { boxShadow: '0 8px 24px rgba(0,0,0,0.1)', minWidth: 180, mt: 1, borderRadius: '12px', border: `1px solid ${ORG_COLORS.border}` },
            }}
          >
            <MenuItem onClick={handleMenuClose} component={NavLink} to="/org/account" sx={{ fontSize: '0.875rem', py: 1.2 }}>
              <FontAwesomeIcon icon={faUserCog} style={{ marginRight: '12px', color: ORG_COLORS.textSecondary }} /> Account Settings
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => { handleMenuClose(); handleLogout(); }} sx={{ fontSize: '0.875rem', py: 1.2 }}>
              <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '12px', color: ORG_COLORS.textSecondary }} /> Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const OrgLayout = ({ children }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const isMobile = useMediaQuery('(max-width: 960px)');
  const location = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${baseURL}/org/profile`, {
          method: 'GET',
          credentials: 'include',
        });
        if (!response.ok) throw new Error('Failed to fetch organization data');
        const userData = await response.json();
        setUser(userData.user);
        setOrganization(userData.organization);


      } catch (error) {
        console.error('Error fetching organization data:', error);
      }
    };
    fetchUserData();
  }, []);


  console.log(organization)
  console.log(user)
  const toggleDrawer = () => setDrawerOpen(!isDrawerOpen);

  const handleLogout = async () => {
    try {
      const response = await fetch(`${baseURL}/auth/user/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      if (!response.ok) throw new Error('Logout failed. Please try again.');
      toast.success('Logged out successfully!');
      setTimeout(() => {
        window.location.href = '/user/login';
      }, 2000);
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed. Try again.');
    }
  };

  const isActive = (path) => location.pathname === path;

  const drawerContent = (
    <Box
      sx={{
        width: drawerWidth,
        backgroundColor: ORG_COLORS.background,
        color: ORG_COLORS.text,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {isMobile && (
        <IconButton onClick={toggleDrawer} sx={{ color: ORG_COLORS.textSecondary, position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </IconButton>
      )}

      {/* Brand header */}
      <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5 }}>
        <Box sx={{ mb: 2 }}>
          <img src={ORGANIZATION_FULL_LOGO} alt="Yamba Logo" style={{ height: '32px' }} />
        </Box>

        {/* Org profile card */}
        <Box display="flex" alignItems="center" sx={{ p: 1.5, borderRadius: '12px', backgroundColor: ORG_COLORS.backgroundLight, border: `1px solid ${ORG_COLORS.border}` }}>
          {organization?.logo_url ? (
            <Avatar src={organization.logo_url} alt={organization.name} sx={{ width: 38, height: 38, mr: 1.5 }} />
          ) : (
            <Avatar sx={{ width: 38, height: 38, mr: 1.5, fontSize: '1rem' }}>
              {organization?.name?.[0]?.toUpperCase() || 'O'}
            </Avatar>
          )}
          <Box sx={{ overflow: 'hidden' }}>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.875rem', color: ORG_COLORS.text, lineHeight: 1.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {organization?.name || 'Loading...'}
            </Typography>
            <Typography variant="caption" sx={{ color: ORG_COLORS.textSecondary, fontSize: '0.72rem', lineHeight: 1.2 }}>
              Organisation
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ borderColor: ORG_COLORS.border, mx: 2 }} />

      {/* Nav list */}
      <Box sx={{ flex: 1, overflowY: 'auto', px: 1.5, py: 1 }}>
        <List disablePadding>
          {[
            { to: '/org/dashboard', label: 'Dashboard', icon: faChartLine },
            { to: '/org/members', label: 'Members', icon: faUsers },
            { to: '/org/campaigns', label: 'Campaigns', icon: faBullhorn },
            { to: '/org/email', label: 'Send Emails', icon: faEnvelope },
            { to: '/org/memberships', label: 'Memberships & Events', icon: faIdCard },
            { to: '/org/transactions', label: 'Transactions', icon: faCreditCard },
            { to: '/org/help', label: 'Help Center', icon: faLifeRing },
            { to: '/org/account', label: 'Account', icon: faUserCog },
          ].map((item, index) => {
            const isSelected = item.to && isActive(item.to);
            const listItemStyle = {
              cursor: 'pointer',
              borderRadius: '10px',
              backgroundColor: isSelected ? ORG_COLORS.primaryLight : 'transparent',
              borderLeft: isSelected ? `3px solid ${ORG_COLORS.primary}` : '3px solid transparent',
              transition: 'all 0.18s ease',
              textDecoration: 'none',
              color: isSelected ? ORG_COLORS.primary : ORG_COLORS.text,
              display: 'flex',
              alignItems: 'center',
              mb: 0.5,
              px: 1.5,
              py: 1.1,
              '&:hover': {
                backgroundColor: ORG_COLORS.hoverBackground,
                color: ORG_COLORS.primary,
                borderLeft: `3px solid ${ORG_COLORS.primary}40`,
                '& .nav-icon': { color: ORG_COLORS.primary },
              },
            };

            return (
              <ListItem
                key={index}
                component={NavLink}
                to={item.to}
                onClick={() => isMobile && setDrawerOpen(false)}
                sx={listItemStyle}
              >
                <Box className="nav-icon" sx={{ mr: 1.5, color: isSelected ? ORG_COLORS.primary : ORG_COLORS.textSecondary, fontSize: '15px', width: 18, textAlign: 'center', transition: 'color 0.18s ease' }}>
                  <FontAwesomeIcon icon={item.icon} />
                </Box>
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontWeight: isSelected ? 700 : 500, fontSize: '0.9rem', lineHeight: 1 }}>
                      {item.label}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </Box>

      <Box sx={{ px: 1.5, pb: 2 }}>
        <Divider sx={{ mb: 1, borderColor: ORG_COLORS.border }} />
        <ListItem
          onClick={() => { handleLogout(); setDrawerOpen(false); }}
          sx={{
            cursor: 'pointer',
            borderRadius: '10px',
            borderLeft: '3px solid transparent',
            transition: 'all 0.18s ease',
            color: ORG_COLORS.text,
            px: 1.5,
            py: 1.1,
            '&:hover': { backgroundColor: ORG_COLORS.hoverBackground, color: ORG_COLORS.primary },
          }}
        >
          <Box sx={{ mr: 1.5, color: ORG_COLORS.textSecondary, fontSize: '15px', width: 18, textAlign: 'center' }}>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </Box>
          <ListItemText primary={<Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.9rem', lineHeight: 1 }}>Logout</Typography>} />
        </ListItem>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <OrganizationHeader onMenuClick={toggleDrawer} user={user} handleLogout={handleLogout} organization={organization}/>
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
        {isMobile ? (
          <Drawer
            variant="temporary"
            open={isDrawerOpen}
            onClose={toggleDrawer}
            ModalProps={{ keepMounted: true }}
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 2,
              '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
              '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
            }}
          >
            {drawerContent}
          </Drawer>
        ) : (
          <Drawer
            variant="permanent"
            sx={{
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                borderRight: `1px solid ${ORG_COLORS.border}`,
                backgroundColor: ORG_COLORS.background,
              }
            }}
            open
          >
            {drawerContent}
          </Drawer>
        )}
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default OrgLayout;